

// paletteFromHex('#2563eb') — _template's `colors.primary`.
const defaultPrimary = {
	50: '#E9EFFD',
	100: '#CFDDFB',
	200: '#A8C1F7',
	300: '#7CA1F3',
	400: '#5182EF',
	500: '#2563EB',
	600: '#1F54C8',
	700: '#1A45A5',
	800: '#143681',
	900: '#0F285E',
}

// paletteFromHex('#64748b') — _template's `colors.secondary`.
const defaultSecondary = {
	50: '#F0F1F3',
	100: '#DDE0E5',
	200: '#C1C7D1',
	300: '#A2ACB9',
	400: '#8390A2',
	500: '#64748B',
	600: '#556376',
	700: '#465161',
	800: '#37404C',
	900: '#282E38',
}

export const colors = {
	primary: defaultPrimary,
	secondary: defaultSecondary,
}
